module.exports = __webpack_public_path__ + "images/stickers/taco-active.8f34b8d33ea0a3df3906.png";